import React       from 'react';
import ReactDom    from 'react-dom';
import Moment      from 'moment';

import Const       from 'fw_const';
import Utils       from 'utils';

import ContentsModal    from 'contents_modal';
// -------------------------------------------------------

class Line extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.item = {};
  }
  // -------------------------------------------------------
  
  update(data_id, value) {
    //this.props.change_ev.bind(this)(this.props.id, this.score.value);
    console.log(data_id +'='+ this.item[data_id].checked +':'+ value);
    
    this.props.change_ev.bind(this)(this.props.id, value);
  }
  // -------------------------------------------------------
  
  render() {
    return (
      <div className="column">
        <h6>{this.props.name}</h6>
        
        { this.props.list.map((d, key) => {
          let data_id = (this.props.id +'_'+ key);
          return (
            <div key={key} className="checkbox-frame">
              <input type="checkbox" id={data_id} ref={(input) => { this.item[data_id] = input }} onChange={this.update.bind(this, data_id, d.id)} className="checkbox" />
              <label className="checkbox" htmlFor={data_id}>{d.name}</label>
            </div>
          );
        })}
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default Line;